import React, { useCallback } from 'react';

import { useAppDispatch } from '../../../../hooks/react-redux';
import { LongText } from '../../../shared/longtext/LongText';
import { Scrollable } from '../../../shared/scrollable/Scrollable';
import { InformationTooltip } from '../../../shared/tooltip';
import styles from '../DocumentName.module.scss';
import { SystemDocumentNameDB, updateValue } from '../store';

interface ScheduleProps {
    systemDocumentName: SystemDocumentNameDB;
}

export const Schedule: React.FC<ScheduleProps> = ({ systemDocumentName }) => {
    const { boilerPlateEndText, scheduleStartText, scheduleEndText } = systemDocumentName;
    const dispatch = useAppDispatch();
    const updateDocumentNameValue = useCallback((key: keyof SystemDocumentNameDB, value: string | null | number | number[]) => dispatch(updateValue(key, value)), [dispatch]);

    return (
        <div className={styles.inputsWrapper}>
            <Scrollable>
                <div className={styles.schedulePageTextWrapper}>
                    <div className={styles.schedulePageText}>
                        <div className={styles.schedulePageTextLabelWrapper}>
                            <div className={styles.schedulePageTextLabel}>Boiler Plate End Text</div>
                            <InformationTooltip content='This should be a sentence that would likely be found on the last page of the boiler plate part of the document' width={300} />
                        </div>
                        <LongText value={boilerPlateEndText || ''} onChange={value => updateDocumentNameValue('boilerPlateEndText', value)} width='100%' maxLength={2000} />
                    </div>
                    <div className={styles.schedulePageText}>
                        <div className={styles.schedulePageTextLabelWrapper}>
                            <div className={styles.schedulePageTextLabel}>Schedule Start Text</div>
                            <InformationTooltip content='This should be a sentence or title that would likely be found on the first page of the schedule of the document. If left blank this will be the page after the boiler plate text or first page.' width={300} />
                        </div>
                        <LongText value={scheduleStartText || ''} onChange={value => updateDocumentNameValue('scheduleStartText', value)} width='100%' maxLength={2000} />
                    </div>
                    <div className={styles.schedulePageText}>
                        <div className={styles.schedulePageTextLabelWrapper}>
                            <div className={styles.schedulePageTextLabel}>Schedule End Text</div>
                            <InformationTooltip content='This should be a sentence that would likely be found on the last page of the schedule of the document. If left blank this will default to the last page of the document.' width={300} />
                        </div>
                        <LongText value={scheduleEndText || ''} onChange={value => updateDocumentNameValue('scheduleEndText', value)} width='100%' maxLength={2000} />
                    </div>
                </div>
            </Scrollable>
        </div>
    );
};
